// extracted by mini-css-extract-plugin
export default {"warning-button-icon":"warning-button-icon_yd9Gnviq","popup-text":"popup-text_DPFiXy1I"};